export default {
  verifyIfAnyAccessRemoved(profile, {
    companies: initialCompanies,
    installations: initialInstallations,
    assets: initialAssets,
    modules: initialModules,
  }) {
    const hasCompaniesRemoved = this.hasDifference(initialCompanies, profile.companies, 'id');
    const hasInstallationsRemoved = this.hasDifference(initialInstallations, profile.installations, 'id');
    const hasAssetsRemoved = this.hasDifference(initialAssets, profile.assets, 'id');
    const hasModulesRemoved = this.hasDifference(initialModules, profile.modules, 'id');

    return hasCompaniesRemoved || hasInstallationsRemoved
      || hasAssetsRemoved || hasModulesRemoved;
  },
  hasDifference(mainList, compareList, field) {
    return mainList.filter(
      mainItem => compareList.filter(
        compareItem => compareItem[field] === mainItem[field],
      ).length === 0,
    ).length > 0;
  },
};
